
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber, TreeSelect, Row, Col , Switch } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import validator from '../../../util/validator';
import orgUtil from '../../ui/orgUtil';

const fields = [{
    "text": "所属市场",
    "field": "orgCode",
    org: true,
    rules: [
        { required: true, message: '所属市场不能为空!' },
    ]
}, {
    "text": "会员名称",
    "field": "memberName",
    rules: [
        { required: true, message: '会员名称不能为空!' },
        { max: 32, message: '会员名不能超过32个字符！' },
    ]
}, {
    "text": "竞价会员编号",
    "field": "abbreviation",
    rules: [
        { max: 32, message: '竞价会员编号不能超过32个字符！' },
    ]
}, {
    "text": "证件号码",
    "field": "creditNo",
    rules: [
        { max: 32, message: '证件号码不能超过32个字符！' },
        validator.creditNo
    ]
}, {
    "text": "地址",
    "field": "address",
    rules: [
        { max: 64, message: '地址不能超过64个字符！' },
    ]
}, {
    "text": "联系人",
    "field": "contactMan",
    rules: [
        { max: 16, message: '联系人不能超过64个字符！' },
    ]
}, {
    "text": "联系人证件号",
    "field": "contactManCreditNo",
    rules: [
        validator.creditNo
    ]
}, {
    "text": "联系电话",
    "field": "contactNumber",
    rules: [
        validator.tel
    ]
}, 
{
    "text": "水费",
    "field": "waterFees",
    number: true,
    rules: [
        { required: true, message: '水费不能为空!' },
    ],

}, 
 {
    "text": "当前电表读数",
    "field": "currentElecDegree",
    number: true,
    rules: [
        { required: true, message: '当前电表读数不能为空!' },
    ]
}, {
    "text": "电表倍数",
    "field": "electricityMultiple",
    number: true,
    rules: [
        { required: true, message: '电表倍数不能为空!' },
    ]
}, {
    "text": "每月电费扣减",
    "field": "deduction",
    number: true,
    rules: [
        { required: true, message: '每月电费扣减不能为空!' },
    ]
},{
    "text": "车位数",
    "field": "parkingNumber",
    number: true,
    rules: [
        { required: true, message: '车位数不能为空!' },
        validator.naturalNum
    ]
}
, {
    "text": "是否限制车数",
    "field": "restriction",
    radio: true
}


];


class TenantPropertyEditForm extends Component {

    state = {
        orgList: [],
        firstOrg: '',
    }

    componentDidMount() {
        orgUtil.findOrg(
            { orgType: 4 },   //只查询市场的组织信息
            (res) => {
                let firstOrg = '';
                if (res != null && res.length > 0) {
                    firstOrg = res[0].code;
                }
                this.setState({ orgList: res, firstOrg: firstOrg });
            }
        );
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let memberCode = this.props.editData.memberCode
            if (memberCode !== undefined && memberCode != null) {
                values["memberCode"] = memberCode;
            }
            values["fixedWater"] = values["fixedWater"] ? 1 : 0;
            fields.forEach((json, index) => {
                if (json["radio"] === true) {
                    values[json["field"]] = values[json["field"]] ? 1 : 0;
                }
            })
            http.post({
                url: '/tenant/saveTenant',
                data: values,
                success: (res) => {
                    let queryData = this.props.queryData;
                    this.props.successCallback(queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    //swith选择改变时触发
    radioChange = (value) => {
        const { editData } = this.props;
        if (value) {
            editData.fixedWater = 1;
        } else {
            editData.fixedWater = 0;
        }
    }

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let orgCode = editData.orgCode;
        if (orgCode == null || orgCode === '') {
            orgCode = this.state.firstOrg;
        }
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: item.field === "orgCode" ? orgCode : item.radio ? editData[item.field] === 1 : editData[item.field],
                            valuePropName: item.radio ? 'checked' : 'value'
                        })(
                            item.number ?
                                <InputNumber precision={2} min={0.00} max={999999999} style={{ width: '100%' }} />
                                :item.radio ?
                                    <Switch checkedChildren="是" unCheckedChildren="否" />
                                        : item.org ? <TreeSelect treeData={this.state.orgList} treeDefaultExpandAll={true} />
                                            : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return this.createTwoCol(dom);
    };

    createTwoCol = (dom) => {
        let res = [];
        for (let i = 0; i < dom.length; i += 2) {
            let item = (<Row key={i}>
                <Col span={11}>{dom[i]}</Col>
                <Col span={11} offset={2}>
                    {(i + 1) < dom.length ? dom[i + 1] : ''}
                </Col>
            </Row>
            )
            res.push(item);
        }
        return res;
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={850}
                visible={visible}
                title="租户信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const TenantPropertyEdit = Form.create()(TenantPropertyEditForm);

export default TenantPropertyEdit;